/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { isEmpty, not, pipe, propEq } from 'ramda';
import { createSelector } from 'reselect';

import {
  findWorkspace,
  selectWorkspaceQuery,
  selectWorkspaces
} from '../../common/selectors';
import {
  newEnabledViewPlugins,
  newSettingsValidation,
  selectedWorkspace
} from '../data/prefabs';

export const selectSelectedWorkspace = createSelector(
  selectWorkspaces,
  selectedWorkspace.value,
  selectWorkspaceQuery,
  (workspaces, selected, active) => {
    const id = selected || active;
    return id !== 'new' ? findWorkspace(id)(workspaces) : { id: 'new' };
  }
);

export const selectWorkspaceEditable = createSelector(
  selectSelectedWorkspace,
  workspace => workspace && pipe(
    propEq('type', 'default'),
    not
  )(workspace)
);

export const selectWorkspaceDirty = createSelector(
  selectWorkspaceEditable,
  newEnabledViewPlugins.value,
  newSettingsValidation.value,
  (editable, updatedEnabledViews, updatedValidationSettings) =>
    editable && (!isEmpty(updatedEnabledViews) || !isEmpty(updatedValidationSettings))
);
